import React from 'react';
import { memo } from 'react';

/**
 * MaintenanceBrakePad Icon - Used in Maintenance reminder page
 */
const MaintenanceBrakePadIcon = ({ size = 48 }: { size?: number }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path
        d="M22 44C31.9411 44 40 35.9411 40 26C40 16.0589 31.9411 8 22 8C12.0589 8 4 16.0589 4 26C4 35.9411 12.0589 44 22 44Z"
        fill="#EFF3F7"
      />
      <path
        d="M22 31C24.7614 31 27 28.7614 27 26C27 23.2386 24.7614 21 22 21C19.2386 21 17 23.2386 17 26C17 28.7614 19.2386 31 22 31Z"
        fill="#D9E0E9"
      />
      <path
        d="M22 47C17.8466 47 13.7865 45.7684 10.333 43.4609C6.8796 41.1534 4.18798 37.8736 2.59854 34.0364C1.0091 30.1991 0.593229 25.9767 1.40352 21.9031C2.21381 17.8295 4.21386 14.0877 7.15077 11.1508C10.0877 8.21386 13.8295 6.21381 17.9031 5.40352C21.9767 4.59323 26.1991 5.0091 30.0364 6.59854C33.8736 8.18798 37.1534 10.8796 39.4609 14.333C41.7684 17.7865 43 21.8466 43 26C42.9937 31.5676 40.7791 36.9053 36.8422 40.8422C32.9053 44.7791 27.5676 46.9937 22 47ZM22 11C19.0333 11 16.1332 11.8797 13.6665 13.528C11.1997 15.1762 9.27713 17.5189 8.14182 20.2598C7.0065 23.0007 6.70945 26.0166 7.28823 28.9264C7.86701 31.8361 9.29562 34.5088 11.3934 36.6066C13.4912 38.7044 16.1639 40.133 19.0737 40.7118C21.9834 41.2906 24.9994 40.9935 27.7403 39.8582C30.4812 38.7229 32.8238 36.8003 34.4721 34.3336C36.1203 31.8668 37 28.9667 37 26C36.9958 22.0231 35.4141 18.2102 32.6019 15.3981C29.7898 12.586 25.977 11.0042 22 11Z"
        fill="#6E7E91"
      />
      <path
        d="M46 28H34C33.7348 28 33.4804 27.8946 33.2929 27.7071C33.1054 27.5196 33 27.2652 33 27C32.9966 23.8185 31.7312 20.7682 29.4815 18.5185C27.2318 16.2688 24.1815 15.0034 21 15C20.7348 15 20.4804 14.8946 20.2929 14.7071C20.1054 14.5196 20 14.2652 20 14V2C20 1.73478 20.1054 1.48043 20.2929 1.29289C20.4804 1.10536 20.7348 1 21 1C27.8933 1.00768 34.502 3.74942 39.3763 8.6237C44.2506 13.498 46.9923 20.1067 47 27C47 27.2652 46.8946 27.5196 46.7071 27.7071C46.5196 27.8946 46.2652 28 46 28Z"
        fill="#FF3975"
      />
      <path
        d="M26.5 10C27.3284 10 28 9.32843 28 8.5C28 7.67157 27.3284 7 26.5 7C25.6716 7 25 7.67157 25 8.5C25 9.32843 25.6716 10 26.5 10Z"
        fill="#E81656"
      />
      <path
        d="M39.5 23C40.3284 23 41 22.3284 41 21.5C41 20.6716 40.3284 20 39.5 20C38.6716 20 38 20.6716 38 21.5C38 22.3284 38.6716 23 39.5 23Z"
        fill="#E81656"
      />
      <path
        d="M34.5 15C35.3284 15 36 14.3284 36 13.5C36 12.6716 35.3284 12 34.5 12C33.6716 12 33 12.6716 33 13.5C33 14.3284 33.6716 15 34.5 15Z"
        fill="#E81656"
      />
    </svg>
  );
};
export default memo(MaintenanceBrakePadIcon);
